import React, { useContext, useEffect, useState } from "react";
import css from "../css/Refer.module.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import { BsWhatsapp } from "react-icons/bs";
import { BsChevronDown } from 'react-icons/bs';
import { BsPerson } from 'react-icons/bs';
import { BsCash } from 'react-icons/bs';

import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
import CopyToClipboard from "react-copy-to-clipboard";
import { FaTelegramPlane } from "react-icons/fa";
import { FiCopy } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);
  const theme = localStorage.getItem('theme')


  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const [cardData, setGame] = useState([]);

  const copyCode = (e) => {
    navigator.clipboard.writeText(user.referral_code);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const copyLink = (e) => {
    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referal Link Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  if (user === undefined) {
    return null;
  }

  const referralText = `Hi Friends, Play Rajwadaludo Ludo and earn 10000 daily. Download Indian App Rajwadaludo
  बम्मफर  धमाका ऑफर  💸💸💸 💥💥💥💥💥💥
   दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा
  
    NK ADDA पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
    100% भरोसेमंद प्लेटफार्म । 24 hours support https://Rajwadaludo.in/login/${user.referral_code}
    
    Your ReferralCode is -${user.referral_code}.`


  // language 


  const translations = {
    hi: {
      referral: 'आपकी रेफरल कमाई',
      referPerson: 'आमंत्रित किये दोस्त | ',
      referEarn: 'रेफरल कमाई  ',
      referCode: 'रेफरल कोड ',
    },
    en: {
      referral: 'Your Referral Earnings',
      referPerson: 'Referred Players',
      referEarn: 'Referral Earning',
      referCode: 'Referral Code',
    },
  };

  // change theme 

  const styles = {
    backgroundColor: theme === 'light' ? '#E8FFF4' : 'black',
    color: theme === 'light' ? 'black' : 'black',
  };
  const styles1 = {
    color: theme === 'light' ? 'black' : 'white',
  };


  return (
    <>
      {/* <Header user={user} /> */}
      <div className="leftContainer"
          style={{ ...styles, minHeight: "100vh", height: "100%" }} style={styles}>
  <div
    className="refer-modern-page"
    style={{ ...styles, minHeight: "100vh" }}
  >
    <section className="refer-main-wrapper">

      {/* Hero Card */}
      <div className="refer-hero-card">

        <div className="refer-hero-left">
          <span className="refer-badge">
            Invite & Earn
          </span>

          <h1 className="refer-title">
            Refer Friends <br />
            Earn Real Cash
          </h1>

          <p className="refer-desc">
            Invite your friends and earn commission
            every time they play games.
          </p>
        </div>

        <div className="refer-hero-right">
          <img
            src="./images/refer.png"
            alt=""
            className="refer-hero-img"
          />
        </div>
      </div>

      {/* Referral Code */}
      <div className="referral-code-card">

        <div className="referral-code-top">
          <h2>{translations[language].referCode}</h2>

          <div className="live-dot"></div>
        </div>

        <div className="referral-code-box">
          <span>{user.referral_code}</span>

          <button
            onClick={(e) => copyCode(e)}
            className="copy-btn-modern"
          >
            Copy
          </button>
        </div>
      </div>

      {/* WhatsApp Share */}
      <a
        className="whatsapp-modern-btn"
        href={`whatsapp://send?text=Play%20On%20Rajwadaludo%20https%3A%2F%2FRajwadaludo.in%2Flogin%2F${user.referral_code}`}
      >
        <BsWhatsapp className="mr-2" />
        Invite on WhatsApp
      </a>

      {/* Stats */}
      <h2 className="stats-heading">
        {translations[language].referral}
      </h2>

      <div className="refer-stats-grid">

        {/* Total Referral */}
        <div className="stats-card referral-card">

          <div>
            <h5>
              {translations[language].referPerson}
            </h5>

            <h3>
              {user.referral_user?.length}
            </h3>
          </div>

          <div className="stats-icon-box">
            <img src="/images/trophyy.png" alt="" />
          </div>
        </div>

        {/* Total Earnings */}
        <div className="stats-card earning-card">

          <div>
            <h5>
              {translations[language].referEarn}
            </h5>

            <h3>
              ₹{user.referral_earning}
            </h3>
          </div>

          <div className="stats-icon-box">
            <img
              src="/images/indian-rupee-money-bag.png"
              alt=""
            />
          </div>
        </div>

      </div>

      {/* How it Works */}
      <div className="how-it-works-card">

        <h2>How It Works</h2>

        <div className="work-step">
          <div className="step-number">1</div>

          <p>
            Share your referral code with friends.
          </p>
        </div>

        <div className="work-step">
          <div className="step-number">2</div>

          <p>
            Friends join and start playing games.
          </p>
        </div>

        <div className="work-step">
          <div className="step-number">3</div>

          <p>
            Earn commission on every game they play.
          </p>
        </div>

      </div>

    </section>
  </div>
</div>
    </>
  );
};

export default Refer;
